<template>
  <div>
    <div class="row margin-bottom-20">
      <div class="col-md-6">
        <div class="form-group">
          <label class="col-md-4 control-label">{{ 'job.create.fields.file' | trans }}:</label>
          <div class="col-md-8">
            <upload-file-manual
                ref="uploadFileManual"
                v-model="form.entity.file"
                :errors="form.options.errors"
                accept=".csv"
                name="file"
            />
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <label class="col-md-3 control-label">
          {{ 'job.create.fields.discount_code' | trans }}:
        </label>
        <div class="col-md-8">
          <single-select
              v-model="form.entity.discountCodeId"
              :allow-empty="false"
              :checked="form.entity.discountCodeId"
              :options="formattedDiscountCodes"
              label="label"
              name="jobTypes"
          />
        </div>
      </div>
    </div>
    <div class="form-actions">
      <div class="row">
        <div class="col-md-12">
          <div class="btn-set pull-right">
            <button
                class="btn green-jungle button-save margin-right-10"
                type="button"
                @click="submitForm">
              {{ 'form.save_and_close' | trans }}
            </button>
            <button
                class="btn default"
                type="button"
                @click="showList">
              {{ 'form.cancel' | trans }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import UploadFileManual from '@component/dccore-form/uploadFileManual.vue'
import SingleSelect from '@component/singleselect.vue'
import toastr from '@js/toastr'
import { DISCOUNT_CODE_TYPE_UNIVERSAL } from '@const/job'

export default {
  name: 'AssignDiscountCodeToClient',
  components: {
    SingleSelect,
    UploadFileManual,
  },
  data() {
    return {
      form: {
        entity: {
          file: null,
          discountCodeId: null,
          type: this.$options.name,
        },
        options: {
          discountCodes: [],
          errors: {},
        },
        jobGrid: Routing.generate('job_grid'),
      },
    }
  },
  computed: {
    formattedDiscountCodes() {
      return this.form.options.discountCodes.map((code) => {
        return Object.assign(code, { label: `id: ${code.id} kod: ${code.code}` })
      })
    },
  },
  mounted: function () {
    this.getDiscountCodes()
  },
  methods: {
    getDiscountCodes() {
      let url = Routing.generate('api_get_discountcodes', {
        context: 'dropdown',
        type: DISCOUNT_CODE_TYPE_UNIVERSAL,
        isNotExpired: true,
        isFutureCodesIncluded: true,
      })
      this.$http.get(url).then(response => {
        this.form.options.discountCodes = response.data
      })
    },
    submitForm() {
      const formData = new FormData()
      for (const key in this.form.entity) {
        if (Object.prototype.hasOwnProperty.call(this.form.entity, key)) {
          formData.append(key, this.form.entity[key])
        }
      }

      const url = Routing.generate('api_post_job')
      this.$emit('loading', true)

      axios.post(url, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
        .then(() => {
          this.$refs.uploadFileManual.$refs.inputFile.value = null
          this.form.entity.discountCode = null
          toastr.success(Translator.trans('job.create.success_message'))
          this.showList()
        }, response => {
          this.handleAjaxError(response, this.form.options)
        })
      this.$emit('loading', false)
    },
    showList() {
      window.location = Routing.generate('job_grid')
    },
  },
}
</script>
